import { ArrowUpRight } from "lucide-react";
import { Reveal, SectionHead } from "./Reveal";

const SERVICES = [
  { n: "01", title: "Fractional CMO Leadership", body: "Embedded C-suite marketing leadership — strategy, team, and budget ownership — at a fraction of a full-time hire." },
  { n: "02", title: "Growth Strategy", body: "End-to-end marketing strategy aligning brand, product, and growth goals to unlock sustainable, measurable revenue." },
  { n: "03", title: "Brand Positioning", body: "Clarifying your market position, narrative, and visual identity so every touchpoint builds recognition and trust." },
  { n: "04", title: "Performance Marketing", body: "Designs, tests, and optimizes paid media across channels for efficient acquisition and profitable CAC-to-LTV ratios." },
  { n: "05", title: "Demand Generation", body: "Integrated campaigns and lead engines that align marketing and sales, grow qualified pipeline, and shorten the path to revenue." },
  { n: "06", title: "Marketing Audits", body: "A forensic review of spend, funnel, and messaging — with a prioritized roadmap of what to fix first and why." },
  { n: "07", title: "Go-To-Market", body: "Positioning, messaging, launch planning, and cross-functional rollout for strong market entry and adoption." },
  { n: "08", title: "Team Management", body: "Lead, mentor, and scale high-performing marketing teams with priorities tied directly to business outcomes." },
  { n: "09", title: "Website Development", body: "Marketing-first websites that strengthen your brand, attract the right customers, and turn traffic into business." },
];

const Services = () => (
  <section id="services" data-testid="services-section" className="px-6 md:px-12 py-24 md:py-36 border-t border-line">
    <div className="mx-auto max-w-[100rem]">
      <SectionHead
        index="03"
        label="Services"
        title={<>One partner. <em className="text-taupe">Every discipline</em> that moves revenue.</>}
      />
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 border-t border-l border-line">
        {SERVICES.map((s, i) => (
          <Reveal key={s.n} delay={(i % 3) * 0.06} className="border-b border-r border-line">
            <div
              data-testid={`service-card-${s.n}`}
              className="group relative h-full p-8 md:p-10 hover:bg-ink transition-colors duration-500 cursor-default"
            >
              <div className="flex items-start justify-between">
                <span className="font-serif italic text-taupe text-lg">{s.n}.</span>
                <ArrowUpRight
                  size={16}
                  className="text-line group-hover:text-taupe transition-all duration-500 group-hover:translate-x-1 group-hover:-translate-y-1"
                />
              </div>
              <h3 className="mt-10 md:mt-16 font-serif text-2xl md:text-3xl font-normal tracking-tight group-hover:text-paper transition-colors duration-500">
                {s.title}
              </h3>
              <p className="mt-4 text-sm font-light text-ash leading-relaxed group-hover:text-paper/70 transition-colors duration-500">
                {s.body}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Services;
